import { render, staticRenderFns } from "./aws-send-sqs.vue?vue&type=template&id=74dfe644&scoped=true"
import script from "./aws-send-sqs.vue?vue&type=script&lang=js"
export * from "./aws-send-sqs.vue?vue&type=script&lang=js"
import style0 from "./aws-send-sqs.vue?vue&type=style&index=0&id=74dfe644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfe644",
  null
  
)

export default component.exports